import { Component } from '@angular/core';
import { CapturumBuilderDefaultInputWrapperComponent } from '@capturum/builders/form-renderer';

@Component({
  selector: 'app-meta-value-wrapper',
  templateUrl: './meta-value-wrapper.component.html',
  styleUrls: ['./meta-value-wrapper.component.scss'],
})
export class MetaValueWrapperComponent extends CapturumBuilderDefaultInputWrapperComponent {}
